module.exports = __webpack_public_path__ + "2178201ba5709d7caa1fa7527d883a20.svg";